<template>
  <v-dialog
    v-model="show"
    width="1000"
  >
    <EditDetailDialog
      v-model="editDetailViewModel"
      :save-callback="onEditDetail"
    />

    <v-card
      class="dialogBackground"
      :disabled="loading"
    >
      <v-row
        no-gutters
        class="dialogTitleBackground white--text px-2 py-1 mb-2"
        align="center"
      >
        <span>Выбор товара</span>
        <v-spacer />
        <KeepWindowOpenedButton
          v-model="keepWindowOpened"
          store-key="RequestAddDetail.KeepWindowOpened"
          tooltip="Не закрывать окно после добавления позиции"
        />
        <v-btn
          small
          icon
          dark
          @click="cancelClick"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>

      <v-row
        align="center"
        justify="center"
        no-gutters
        class="mx-1"
      >
        <v-col
          class="px-1"
          cols="3"
        >
          <v-text-field
            v-model="articleContains"
            dense
            append-icon="mdi-magnify"
            label="Артикул содержит"
            single-line
            hide-details
            autocomplete="off"
            class="pb-4"
            @input="lazyQuery(getItems)"
          />
        </v-col>

        <v-col class="px-1">
          <v-text-field
            v-model="nameContains"
            dense
            append-icon="mdi-magnify"
            label="Наименование содержит"
            single-line
            hide-details
            autocomplete="off"
            class="pb-4"
            @input="lazyQuery(getItems)"
          />
        </v-col>
      </v-row>

      <v-data-table
        dense
        :items="items"
        :headers="headers"
        :loading="loading"
        hide-default-footer
        disable-pagination
        disable-filtering
        disable-sort
        item-key="id"
        loading-text="Загрузка данных..."
        no-data-text="Нет данных, соответствующих фильтру..."
        no-results-text="Совпадений не найдено..."
        class="styled-table pointed-table"
        height="300"
        @click:row="goodClick"
      >
        <template v-slot:[`item.restPallet`]="{ item }">
          {{ item.rests.reduce((acc, c)=>acc+c.qtyPallet, 0) }}
        </template>
        <template v-slot:[`item.restPackage`]="{ item }">
          {{ item.rests.reduce((acc, c)=>acc+c.qty, 0)/item.qiPackage }}
        </template>
      </v-data-table>

      <v-card-actions class="pt-8">
        <v-spacer />
        <v-btn
          class="px-6"
          outlined
          @click.prevent="cancelClick"
        >
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import KeepWindowOpenedButton from "@/components/KeepWindowOpenedButton"
import EditDetailDialog from "./EditDetailDialog"
import lazyQuery from "@/utils/lazyQuery"

export default {
  components: {
    KeepWindowOpenedButton,
    EditDetailDialog
  },

  mixins: [lazyQuery],

  props: {
    value: { type: Object, default: null }, // показать диалог если есть открываемый элемент
    saveCallback: { type: Function, default: function () {} }
  },

  data: () => ({
    // диалог редактирования количества
    editDetailViewModel: null,
    viewModel: {},
    keepWindowOpened: false,
    loading: false,
    // фильтр
    articleContains: "",
    nameContains: "",
    // элементы
    items: [],

    headers: [
      { text: "Артикул", value: "article", class: "tableHeader tableHeaderText--text" },
      { text: "Наименование", value: "name", class: "tableHeader tableHeaderText--text" },
      { text: "В уп.", align: "center", value: "qiPackage", class: "tableHeader tableHeaderText--text" },
      { text: "шт. На поддоне", align: "center", value: "qiPallet", class: "tableHeader tableHeaderText--text" },
      { text: "Цена упаковки", align: "center", value: "price", class: "tableHeader tableHeaderText--text" },
      { text: "Вес шт, кг", align: "center", value: "weight", class: "tableHeader tableHeaderText--text" },
      {
        text: "На складе, упаковок",
        align: "center",
        value: "restPackage",
        class: "tableHeader tableHeaderText--text"
      },
      { text: "На складе, поддонов", align: "center", value: "restPallet", class: "tableHeader tableHeaderText--text" }
    ]
  }),

  computed: {
    show: {
      get() {
        // показываем если id != 0
        return this.viewModel.id
      },
      set(val) {
        if (!val) {
          // сбрасываем объект, который передавали в диалог
          this.$emit("input", null)
        }
      }
    }
  },

  watch: {
    value(val) {
      this.viewModel = {
        ...val,
        // если деталь есть, но это пустой объект, то дать ему id = -1, если null, то 0 иначе id
        id: val?.id ? val.id : val ? -1 : 0
      }
      if (this.viewModel.id === 0) return
      // загрузка элементов
      this.getItems()
    }
  },

  methods: {
    // получение данных
    async getItems() {
      this.loading = true
      await this.axios
        .get("/goods/get", {
          params: {
            page: 1,
            rowsPerPage: 1000000,
            // filter:
            cargoTypeID: this.viewModel.cargoTypeID,
            articleContains: this.articleContains,
            nameContains: this.nameContains
          }
        })
        .then((response) => {
          this.items = response.data
          this.loading = false
        })
        .catch((err) => {
          this.$router.push(`/error?message=Ошибка при получении списка товаров&&error=${err}`)
        })
    },

    async goodClick(item) {
      this.editDetailViewModel = {
        usePartNumber: this.viewModel.usePartNumber,
        requestTypeID: this.viewModel.requestTypeID,
        id: -1,
        goodID: item.id,
        goodName: item.name,
        goodArticle: item.article,
        qiPackage: item.qiPackage,
        qiPallet: item.qiPallet,
        qty: 0,
        partNumber: "",
        productionDate: null
      }
    },

    async onEditDetail(item) {
      this.loading = true
      const result = await this.saveCallback(item)
      this.loading = false
      if (result) {
        this.editDetailViewModel = null
        if (!this.keepWindowOpened) this.show = false
      }
      return result
    },

    cancelClick() {
      this.show = false
    }
  }
}
</script>
